/* eslint-disable react-hooks/exhaustive-deps */
import { Formik } from 'formik';

import DropDown from 'components/form/dropDown';
import PrimaryButton from 'components/form/buttons/primaryButton';
import OutlineButton from 'components/form/buttons/outLineButton';
import { useActions } from 'common/hooks/useActions';

import * as S from './styles';
import * as T from 'common/types';
import { useEffect } from 'react';

interface IProps {
  data: T.Pages.FloorListItem;
  closeModal?: () => void;
  fetchData?: () => void;
  teaboyList: T.Pages.TeaboyListItem[];
}

export default function AssignTeaboyForm({ data, teaboyList, closeModal, fetchData }: IProps) {
  const { teaboysRequestAction, teaboyAssignToFloorRequestAction } = useActions();

  useEffect(() => {
    teaboysRequestAction({ isAdding: true });
  }, []);

  return (
    <S.Content>
      {/*
       * The dialog's name is ModalApp's title now. The centred stack this
       * form drew for itself — a 40px teal disc over a 16px heading — was a
       * heading system that existed in two places in the product and matched
       * nothing else in it.
       */}
      <Formik
        initialValues={{
          id: data?.teaBoy?.userId,
          floor: data?.id || '',
          displayName: data?.teaBoy?.user?.displayName
        }}
        enableReinitialize
        onSubmit={(values, { setSubmitting, resetForm }) => {
          teaboyAssignToFloorRequestAction(values, () => {
            resetForm();
            closeModal && closeModal();
            fetchData && fetchData();
          });
          setSubmitting(false);
        }}
      >
        {({ values, errors, touched, handleSubmit, setValues }) => (
          <>
            <DropDown
              label="Tea boy"
              list={teaboyList.map((item: T.Pages.TeaboyListItem) => {
                return { id: item.id, title: item?.displayName };
              })}
              onChange={(e) => {
                setValues({ ...values, id: e.id as any, displayName: e.title });
              }}
              placeholder="Select or search user"
              key={values.id}
              defaultValue={{
                id: values.id,
                title: values.displayName
              }}
              message={touched.id && errors.id}
              error={errors.id as unknown as boolean}
            />

            <S.Actions>
              <OutlineButton onClick={closeModal}>Cancel</OutlineButton>
              <PrimaryButton onClick={handleSubmit}>Assign</PrimaryButton>
            </S.Actions>
          </>
        )}
      </Formik>
    </S.Content>
  );
}
